import { createContext, useState } from "react";

const EntriesDataContext = createContext({});

export const EntriesDataProvider = ({ children }) => {
  const [resData, setResData] = useState([]);
  const [redirectId, setRedirectId] = useState(1);

  return (
    <EntriesDataContext.Provider
      value={{ resData, setResData, redirectId, setRedirectId }}
    >
      {children}
    </EntriesDataContext.Provider>
  );
};

export default EntriesDataContext;
